import { render, staticRenderFns } from "./productReport.vue?vue&type=template&id=8971e77c&scoped=true&"
import script from "./productReport.vue?vue&type=script&lang=js&"
export * from "./productReport.vue?vue&type=script&lang=js&"
import style0 from "./productReport.vue?vue&type=style&index=0&id=8971e77c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8971e77c",
  null
  
)

export default component.exports